import StatisticsPage from './StatisticsPage'
export default StatisticsPage
